<template>
<div>
    <div class="form-group">
        <label for="hrtJob[type_often]" >{{ __('forms.hrtJobs.type_often') }}</label>
        <select required class="form-control" name="hrtJob[type_often]" v-model="type_often_field" @change="changeOptionsHowOften()">
          <option v-for="(element, id) in type_often_object" v-bind:key="id" :value="id">{{element}}</option>
        </select>
    </div>
    <div class="form-group">
      <label for="hrtJob[how_often]" >{{ __('forms.hrtJobs.how_often') }}</label>
        <select required class="form-control" name="hrtJob[how_often]" v-model="how_often_field">
          <option v-for="(element, id) in how_often_possibilities" v-bind:key="id" :value="id+1">{{element}}</option>
        </select>
    </div>
</div>
</template>
<script>
export default {
  mounted() {    
    if (this.type_often_selected != null){
      this.how_often_possibilities = this.how_often_object[this.type_often_selected][0];
      this.type_often_field = this.type_often_selected
      this.how_often_field = this.how_often_selected;     
    }
  },
  data() { 
    return {
      how_often_possibilities: [],
      type_often_field: null,
      how_often_field: null
    }
  },
  props: {
    type_often_selected: {
      type: String,
      default: null
    },
    how_often_selected: {
      type: Number,
      default: null
    },
    type_often_object: {
      type: Object,
      required: true,
    },
    how_often_object: {
      type: Object,
      required: true,
    },
  },
  methods: {    
    changeOptionsHowOften() {  
      this.how_often_field = null;    
      this.how_often_possibilities = this.how_often_object[this.type_often_field][0];                
    }
  },
};
</script>